import { render, staticRenderFns } from "./AnswerList.vue?vue&type=template&id=decf57f0&scoped=true&"
import script from "./AnswerList.vue?vue&type=script&lang=js&"
export * from "./AnswerList.vue?vue&type=script&lang=js&"
import style0 from "./AnswerList.vue?vue&type=style&index=0&id=decf57f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decf57f0",
  null
  
)

export default component.exports